import React from 'react';
import './Domains.scss';
import HeaderPrint from "../HeaderPrint/HeaderPrint";
import TableDomains from "./TableDomains";

const Domains = ({data}) => {

  try {
    return (
      <>
        {data?.data?.data.map((item, index) => (
          <React.Fragment key={index}>
            <section className="print__domains">
              <HeaderPrint
                englishTitle={"Domains"}
                persianTitle={"دامنه ها"}
                color={"#FFDF00"}
              />
              <div className="table__domains__text iransans-b">
                <div className="table__domains__name">
                  <span>کاربـر</span>
                  <span>:</span>
                  <span>{item.user}</span>
                </div>
                <div className="table__domains__date">
                  <span>تاریخ</span>
                  <span>:</span>
                  <span>{item.date}</span>
                </div>
              </div>
              <div
                className="table__domains__box"
                style={{width: "100%"}}
              >
                <TableDomains tableItems={item.table}/>
              </div>
            </section>
            {index < data?.data?.data.length - 1 && (
              <div style={{pageBreakBefore: "always"}}></div>
            )}
          </React.Fragment>
        ))}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default Domains;